<template>
  <Modal v-model="modal" :title="type=='invest'?$t('title.w57'):$t('title.w58')">
    <div>
      <template v-if="type=='invest'">
        <span class="text">{{$t('msg.m96')}} [{{item.Number}}]</span>
        <span class="amount">
          {{$t('label.w1')}}
          <b>{{item.Amount | money}}{{$t('label.w5')}}[{{bigamount}}]</b>
        </span>
      </template>
      <template v-else>
        <span class="text">{{$t('msg.m97')}} [{{item.Number}}]</span>
        <span class="amount">
          {{$t('label.w2')}}
          <b>{{item.Amount | money}}{{$t('label.w5')}}[{{bigamount}}]</b>
        </span>
      </template>
    </div>
    <template slot="footer">
      <Button type="primary" :loading="loading" @click="submit">{{$t('btn.b30')}}</Button>
    </template>
  </Modal>
</template>
<script>
import { digitUppercase } from "@/libs/static";
export default {
  props: ["type"],
  data() {
    return {
      modal: false,
      item: {},
      loading: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;

      let res;
      if (this.type == "invest") {
        res = await this.$axios.post("/Member/RZJLoan/CancelInvest", {
          investmentSchemeId: this.item.Id
        });
      } else {
        res = await this.$axios.post("/Member/RZJLoan/LoanSchemeCancel", {
          loanSchemeId: this.item.Id
        });
      }

      this.loading = false;
      res.throw();
      if (!res.err) {
        this.modal = false;
        this.$emit("done");
      }
    }
  },
  computed: {
    bigamount() {
      return digitUppercase(this.item.Amount);
    }
  }
};
</script>
<style lang="less" scoped>
.text {
  font-size: 14px;
  line-height: 20px;
}
.amount {
  line-height: 20px;
  color: #8f8f90;
  float: right;
  b {
    color: #ff6106;
    font-weight: normal;
  }
}
</style>
